import { render, staticRenderFns } from "./MdtCheckboxList.vue?vue&type=template&id=55bdfb27&scoped=true"
import script from "./MdtCheckboxList.vue?vue&type=script&lang=js"
export * from "./MdtCheckboxList.vue?vue&type=script&lang=js"
import style0 from "./MdtCheckboxList.vue?vue&type=style&index=0&id=55bdfb27&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55bdfb27",
  null
  
)

export default component.exports